import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { accountsTypesActions } from '../../../application/actions/accountsTypes';

import api from '../../api';

const apiAccountsTypes = api(process.env.REACT_APP_ACCOUNTS_TYPES_API);

export function* fetchAccountsTypes(action) {
  try {
    const { data } = yield call(apiAccountsTypes.get, 'v1/consultar', action.payload);
    /* istanbul ignore next */
    if (data) yield put(accountsTypesActions.fetchAccountsTypesSuccess({data}));
    else yield put(accountsTypesActions.fetchAccountsTypesError());
  } catch (err) {
    console.error('acouuntType saga error:', err);
    yield put(accountsTypesActions.fetchAccountsTypesError());
  }
}

export function* watchFetchAccountsTypes() {
  yield takeLatest(accountsTypesActions.fetchAccountsTypes.type, fetchAccountsTypes);
}
/* istanbul ignore next */
export default function* accountsTypesSaga() {
  yield spawn(watchFetchAccountsTypes);
}
